module.exports = __webpack_public_path__ + "static/image/company/pc/image_vision_2@3x.jpg?abf6f75d";